import { 
  ChangeDetectionStrategy,
  Component, 
  Input,
  ViewEncapsulation, 
} from '@angular/core';

import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { AutoInfo } from '@autos/auto-results/entities/auto-info';

@Component({
  selector: 'app-auto-detail-rate-description',
  templateUrl: './auto-detail-rate-description.component.html',
  styleUrls: ['./auto-detail-rate-description.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AutoDetailRateDescriptionComponent {

  @Input() autoInfo: AutoInfo;

  public readonly fontFamily = TypographyFontFamily;
  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;

  constructor() { }

  get rateDescription(): string { 
    return this.autoInfo?.rateDescription; 
  }


}
